varying vec3 vColor;
varying float vRandom;
uniform float uTime;

void main() {
    float distanceToCenter = distance(gl_PointCoord, vec2(0.5));
    float pct = 1.0 - smoothstep(0.0, 0.5, distanceToCenter);
    vec3 color = vColor;

    // Sparkle / Activity Effect
    // Varied sine wave based on time and random seed
    // High frequency components create "sparkle"
    
    // Base pulse
    float pulse = 0.5 + 0.5 * sin(uTime * 3.0 + vRandom * 6.28);
    
    // Sharp sparkle for some points
    float sparkle = 0.0;
    if (vRandom > 0.8) { // Only 20% of points sparkle intensely
        sparkle = pow(sin(uTime * 5.0 + vRandom * 20.0) * 0.5 + 0.5, 4.0) * 2.0; // Sharp peak
    }

    // Combine
    color += vec3(sparkle); 
    color *= (0.8 + 0.5 * pulse); // General movement

    if (pct < 0.1) discard;
    gl_FragColor = vec4(color, pct * 1.5); // Boost opacity
}
